import { Link } from "react-router-dom";
import { useSEO } from "@/utils/seo";

const structuredData = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "Ana Sayfa",
  description: "Hatay İskenderun, Payas, Dörtyol ve Antakya'da profesyonel ilkyardım eğitimi, iş güvenliği eğitimi ve sağlık eğitimleri. ASSA Akademi ile sertifikalı eğitimler.",
  geo: {
    "@type": "GeoCoordinates",
    latitude: "36.56054574686911",
    longitude: "36.158836937043645",
  },
};

export default function HomePage() {
  useSEO({
    title: "Hatay İlkyardım Eğitimi | ASSA Akademi İskenderun Payas Dörtyol",
    description: "Hatay İskenderun, Payas, Dörtyol ve Antakya'da profesyonel ilkyardım eğitimi, iş güvenliği eğitimi ve sağlık eğitimleri. ASSA Akademi ile sertifikalı eğitimler.",
    canonical: "/",
    ogTitle: "Hatay İlkyardım Eğitimi | ASSA Akademi İskenderun Payas Dörtyol",
    ogDescription: "Hatay İskenderun, Payas, Dörtyol ve Antakya'da profesyonel ilkyardım eğitimi, iş güvenliği eğitimi ve sağlık eğitimleri. ASSA Akademi ile sertifikalı eğitimler.",
    structuredData,
  });

  const whatsappNumber = '905354971053';
  const handleWhatsAppClick = (message: string) => {
    window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const services = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'İlkyardım Eğitimi',
      description: 'Sağlık Bakanlığı onaylı temel ilkyardım, güncelleme ve eğitici eğitimi programları',
      link: '/egitimler'
    },
    {
      icon: 'ri-fire-line',
      title: 'Yangın Güvenliği',
      description: 'Yangın söndürme teknikleri ve acil durum prosedürleri eğitimi',
      link: '/egitimler'
    },
    {
      icon: 'ri-shield-line',
      title: 'Yüksekte Çalışma',
      description: 'IRATA L3 eğitmenlerle güvenli yüksekte çalışma teknikleri',
      link: '/egitimler'
    },
    {
      icon: 'ri-hand-sanitizer-line',
      title: 'Hijyen Eğitimleri',
      description: 'Gıda hijyeni ve iş yeri hijyen standartları eğitimi',
      link: '/egitimler'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Mesleki Eğitim',
      description: 'Üniversite onaylı mesleki yeterlilik belgesi programları',
      link: '/egitimler'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'MYK Danışmanlığı',
      description: 'Mesleki Yeterlilik Kurumu süreçleri için danışmanlık',
      link: '/egitimler'
    }
  ];

  const stats = [
    { number: '10.000+', label: 'Eğitim Verilen Kursiyer' },
    { number: '8+', label: 'Farklı Eğitim Programı' },
    { number: '100%', label: 'Resmi Onaylı Sertifika' },
    { number: '15+', label: 'Yıllık Deneyim' }
  ];

  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'MEB Onaylı Sertifikalar',
      description: 'Tüm eğitimlerimiz resmi onaylı ve geçerli sertifikalıdır'
    },
    {
      icon: 'ri-team-line',
      title: 'Uzman Eğitmen Kadrosu',
      description: 'Alanında deneyimli ve sertifikalı eğitmenlerimiz'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Esnek Eğitim Saatleri',
      description: 'İhtiyaçlarınıza uygun hafta içi ve hafta sonu eğitimler'
    },
    {
      icon: 'ri-building-line',
      title: 'Modern Eğitim Tesisi',
      description: 'Tam donanımlı ve konforlu eğitim ortamı'
    }
  ];

  return (
    <main className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white/95 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/ede399742c23acc022a6d1371ced0eef.jpeg" 
                alt="ASSA Akademi Logo" 
                className="h-12 w-auto"
              />
            </Link>
            
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-gray-900 hover:text-teal-600 font-medium transition-colors whitespace-nowrap">Ana Sayfa</Link>
              <Link to="/egitimler" className="text-gray-700 hover:text-teal-600 font-medium transition-colors whitespace-nowrap">Eğitimler</Link>
              <Link to="/hakkimizda" className="text-gray-700 hover:text-teal-600 font-medium transition-colors whitespace-nowrap">Hakkımızda</Link>
              <Link to="/blog" className="text-gray-700 hover:text-teal-600 font-medium transition-colors whitespace-nowrap">Blog</Link>
              <Link to="/iletisim" className="text-gray-700 hover:text-teal-600 font-medium transition-colors whitespace-nowrap">İletişim</Link>
              <button
                onClick={() => handleWhatsAppClick('Merhaba, bilgi almak istiyorum.')}
                className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-2.5 rounded-lg font-semibold transition-all whitespace-nowrap"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                İletişime Geç
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-32 pb-24 bg-gradient-to-br from-gray-900 via-gray-800 to-teal-900 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://public.readdy.ai/ai/img_res/166cc0c3b52c236a30c287924d5518ea.jpg"
            alt="Background"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
                Hatay'ın Güvenilir <span className="text-teal-400">İlkyardım</span> Eğitim Merkezi
              </h1>
              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                İskenderun, Payas, Dörtyol ve Antakya'da profesyonel ilkyardım, yangın güvenliği ve iş güvenliği eğitimleri. Uzman kadromuz ve 15+ yıllık deneyimimizle yanınızdayız.
              </p>
              <div className="flex flex-wrap gap-4">
                <Link
                  to="/egitimler"
                  className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all inline-flex items-center space-x-2 whitespace-nowrap hover:scale-105 shadow-lg"
                >
                  <span>Eğitimleri İncele</span>
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <button
                  onClick={() => handleWhatsAppClick('Merhaba, eğitimler hakkında bilgi almak istiyorum.')}
                  className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-2 border-white/30 px-8 py-4 rounded-lg font-bold text-lg transition-all inline-flex items-center space-x-2 whitespace-nowrap hover:scale-105"
                >
                  <i className="ri-whatsapp-line"></i>
                  <span>WhatsApp</span>
                </button>
              </div>
            </div>
            
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20first%20aid%20training%20instructor%20demonstrating%20CPR%20on%20mannequin%20to%20attentive%20students%20in%20modern%20bright%20classroom%20medical%20equipment%20visible%20clean%20simple%20background%20educational%20atmosphere%20realistic%20detailed&width=800&height=600&seq=hero001&orientation=landscape"
                alt="ASSA Akademi İlkyardım Eğitimi"
                className="rounded-2xl shadow-2xl w-full h-auto object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-teal-600 mb-2">{stat.number}</div>
                <div className="text-gray-700 font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Eğitim Programlarımız
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              İş güvenliği ve mesleki gelişim alanında kapsamlı eğitim programları sunuyoruz
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <Link
                key={index}
                to={service.link}
                className="group bg-white p-8 rounded-2xl shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-teal-600 to-teal-700 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  {service.description}
                </p>
                <div className="flex items-center text-teal-600 font-semibold group-hover:translate-x-2 transition-transform">
                  <span>Detaylı Bilgi</span>
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Neden ASSA Akademi?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Hatay bölgesinde iş güvenliği eğitiminde öncü kurumuz
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${feature.icon} text-4xl text-teal-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-r from-teal-600 to-teal-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Hemen Eğitime Başlayın
          </h2>
          <p className="text-xl text-teal-50 mb-10 leading-relaxed">
            Profesyonel eğitim programlarımız hakkında detaylı bilgi almak ve kayıt olmak için bizimle iletişime geçin
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <button
              onClick={() => handleWhatsAppClick('Merhaba, eğitim kayıt olmak istiyorum.')}
              className="bg-white hover:bg-gray-100 text-teal-600 px-8 py-4 rounded-lg font-bold text-lg transition-all inline-flex items-center space-x-2 whitespace-nowrap hover:scale-105 shadow-lg"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              <span>WhatsApp ile İletişime Geç</span>
            </button>
            <Link
              to="/iletisim"
              className="bg-teal-800 hover:bg-teal-900 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all inline-flex items-center space-x-2 whitespace-nowrap hover:scale-105"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>Bizi Arayın</span>
            </Link>
          </div>
        </div>
      </section>

      {/* Merkez Web Sitesi Section */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white rounded-2xl shadow-xl p-12 border border-gray-100">
            <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-global-line text-4xl text-teal-600"></i>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              ASSA Akademi Merkez
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Tüm eğitim programlarımız, kurumsal bilgilerimiz ve detaylı içerikler için merkez web sitemizi ziyaret edin.
            </p>
            <a
              href="https://www.assaakademi.com.tr"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-3 bg-teal-600 hover:bg-teal-700 text-white px-10 py-4 rounded-lg font-bold text-lg transition-all hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap"
            >
              <span>www.assaakademi.com.tr</span>
              <i className="ri-external-link-line text-xl"></i>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div>
              <Link to="/" className="inline-block mb-4">
                <img 
                  src="https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/ede399742c23acc022a6d1371ced0eef.jpeg" 
                  alt="ASSA Akademi Logo" 
                  className="h-12 w-auto brightness-0 invert"
                />
              </Link>
              <p className="text-gray-400 text-sm leading-relaxed">
                Hatay'da iş güvenliği ve mesleki eğitim alanında güvenilir çözüm ortağınız.
              </p>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Hızlı Linkler</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-gray-400 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">Ana Sayfa</Link></li>
                <li><Link to="/egitimler" className="text-gray-400 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">Eğitimler</Link></li>
                <li><Link to="/hakkimizda" className="text-gray-400 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">Hakkımızda</Link></li>
                <li><Link to="/blog" className="text-gray-400 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">Blog</Link></li>
                <li><Link to="/iletisim" className="text-gray-400 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">İletişim</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Eğitimler</h4>
              <ul className="space-y-2">
                <li><Link to="/egitimler" className="text-gray-400 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">İlkyardım Eğitimi</Link></li>
                <li><Link to="/egitimler" className="text-gray-400 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">Yangın Güvenliği</Link></li>
                <li><Link to="/egitimler" className="text-gray-400 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">Yüksekte Çalışma</Link></li>
                <li><Link to="/egitimler" className="text-gray-400 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">Hijyen Eğitimleri</Link></li>
                <li><Link to="/egitimler" className="text-gray-400 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">Mesleki Eğitim</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">İletişim</h4>
              <ul className="space-y-3">
                <li className="flex items-start text-sm">
                  <i className="ri-map-pin-line text-teal-400 mr-2 mt-1"></i>
                  <span className="text-gray-400">İskenderun, Hatay</span>
                </li>
                <li className="flex items-center text-sm">
                  <i className="ri-phone-line text-teal-400 mr-2"></i>
                  <a href="tel:+908503462772" className="text-gray-400 hover:text-teal-400 transition-colors whitespace-nowrap">0850 346 27 72</a>
                </li>
                <li className="flex items-center text-sm">
                  <i className="ri-whatsapp-line text-teal-400 mr-2"></i>
                  <button onClick={() => handleWhatsAppClick('Merhaba')} className="text-gray-400 hover:text-teal-400 transition-colors whitespace-nowrap">WhatsApp</button>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-8 text-center">
            <p className="text-gray-400 text-sm">
              © 2025 ASSA Akademi. Tüm hakları saklıdır. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-teal-400 hover:text-teal-300 transition-colors whitespace-nowrap">Website Builder</a>
            </p>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp Button */}
      <button
        onClick={() => handleWhatsAppClick('Merhaba, bilgi almak istiyorum.')}
        className="fixed bottom-6 right-6 w-16 h-16 bg-teal-600 hover:bg-teal-700 text-white rounded-full shadow-2xl hover:shadow-3xl transition-all z-50 flex items-center justify-center hover:scale-110"
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </button>
    </main>
  );
}
